import axios from "axios";
import React, { useState } from "react";
import ConfirmAlert from "./common/ConfirmAlert";
import Swal from 'sweetalert2';
// var generator = require('generate-password'); anas
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [emailStatus, setEmailStatus] = useState(null);
  const [generatedPassword, setGeneratedPassword] = useState("");

  function generatePassword(options) {
    const defaultOptions = {
      length: 36,
      lowercase: true,
      uppercase: true,
      numbers: true,
      symbols: false,
    };

    const merged = { ...defaultOptions, ...options };
    let chars = "";

    if (merged.lowercase) chars += "abcdefghijklmnopqrstuvwxyz";
    if (merged.uppercase) chars += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (merged.numbers) chars += "0123456789";

    let result = "";
    for (let i = 0; i < merged.length; i++) {
      const idx = Math.floor(Math.random() * chars.length);
      result += chars[idx];
    }
    return result;
  }

  //validat email
  const validateEmail = (value) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(value)) setEmailStatus("valid");
    else setEmailStatus("invalid");
  };

  //send otp
  const handleSendOTP = async () => {
    const tempPwd = generatePassword({});
    setGeneratedPassword(tempPwd);

    try {
      await axios.post(
        process.env.REACT_APP_API_ROOT_URL_PREFIX + "/sendEmail",
        { email, password: tempPwd }
      );

      toast.success("OTP sent to your email");
    } catch (e) {
      toast.error("Failed to send OTP");
    }
  };

  //reset password submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp || !newPassword) {
      toast.error("Enter OTP & New Password");
      return;
    }

    try {
      const response = await axios.put(
        process.env.REACT_APP_API_ROOT_URL_PREFIX + "/updateLoginMaster",
        {
          email,
          otp,
          newPassword,
        }
      );

      if (response.data.response === true) {
        toast.success("Password updated successfully");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        toast.error(response.data.msg || "Invalid OTP");
      }
    } catch (e) {
      toast.error("Error updating password");
    }
  };

  return (
    <>
      <div className="container py-5">
        <div className="row d-flex justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-8 col-12">

            <h3 className="text-center">Forgot Password</h3>

            <div className="card p-4">

              {/* EMAIL */}
              <label>Email *</label>
              <input
                type="text"
                className="form-control mb-2"
                onChange={(e) => {
                  setEmail(e.target.value);
                  validateEmail(e.target.value);
                }}
              />

              {emailStatus === "invalid" && (
                <small style={{ color: "red" }}>Invalid email format</small>
              )}

              <button
                className="btn btn-primary mt-2"
                disabled={emailStatus !== "valid"}
                onClick={handleSendOTP}
              >
                Send OTP
              </button>

              <hr />

              {/* OTP */}
              <label>Enter OTP</label>
              <input
                type="text"
                className="form-control mb-3"
                onChange={(e) => setOtp(e.target.value)}
              />

              {/* NEW PASSWORD */}
              <label>New Password</label>
              <input
                type="password"
                className="form-control mb-4"
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <button className="btn btn-success w-100" onClick={handleSubmit}>
                Reset Password
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default ForgotPassword;